  $(document).ready(function(){
    // Show the 'featured' tab by default
    getArticle('featured','id_featured');
    getArticle('trending','id_trending');
    $('#id_featured').show();
    $('#id_trending').hide();
    $('#featured_btn').addClass('tab-active');

    $('#featured_btn').on('click', function(){

      $('#id_featured').show();
      $('#id_trending').hide();
      $(this).addClass('tab-active');
      $('#trending_btn').removeClass('tab-active');
    });
    $('#trending_btn').on('click', function(){
      $('#id_trending').show();
      $('#id_featured').hide();

      $(this).addClass('tab-active');
      $('#featured_btn').removeClass('tab-active');
    });
  });

  //   function getArtilce(tags, id){
  //     console.log(tags);
  //     var requestOptions = {
  //         method: 'GET',
  //         redirect: 'follow'
  //     };
  //   console.log(requestOptions,'data')
  //     fetch("https://fanarchpartners.com/api/getArticlesByTag?tags=" + tags, requestOptions)
  //         .then(response => response.text())
  //         .then(result => {
  //             // Parse the response text into a JavaScript array
  //             var dataArray = JSON.parse(result);
  //             console.log(dataArray[tags]);
  //             var articles =dataArray[tags];
  //             var selector = document.getElementById(id);    
  //             selector.innerHTML = "";
  //             var ulElement = document.createElement("ul");
  //             selector.appendChild(ulElement);
  //               if (Array.isArray(articles)) {
  //                 articles.forEach(article => {
  //                     const formattedTimeDifference = formatTimeDifference(article.article_created_at);
  //                     console.log(article.article_title);
  //                     console.log(article.article_handle);
  //                     var liElement = document.createElement("li");
  //                     var aElement = document.createElement("a");
  //                     var timeSpan = document.createElement("span");
  //                     aElement.href = 'https://fanarch.com/blogs/'+article.blog_handle+'/' + article.article_handle;
  //                     aElement.innerHTML = article.article_title;
  //                     timeSpan.innerHTML = formattedTimeDifference;
  //                     liElement.appendChild(aElement);
  //                     liElement.appendChild(timeSpan);
  //                     ulElement.appendChild(liElement);
  //                 });
  //             } else {
  //                 console.error("No articles found for the specified tags.");
  //             }
  //         })
  //         .catch(error => console.log('error', error));
  // }

  //    function formatTimeDifference(inputDate) {
  //     // Parse the input date string
  //     const inputDateTime = new Date(inputDate);
  //     // Get the current date and time
  //     const now = new Date();
  //     // Calculate the time difference in milliseconds
  //     const timeDifference = now - inputDateTime;

  //     // Convert milliseconds to seconds, minutes, hours, days, and years
  //     const seconds = Math.floor(timeDifference / 1000);
  //     const minutes = Math.floor(seconds / 60);
  //     const hours = Math.floor(minutes / 60);
  //     const days = Math.floor(hours / 24);
  //     const months = Math.floor(days / 30);
  //     const years = Math.floor(months / 12);
  //     if (years >= 1) {
  //         return `${years}y`;
  //     } else if (months >= 1) {
  //         return `${months}mo`;
  //     } else if (days >= 1) {
  //         return `${days}d`;
  //     } else if (hours >= 1) {
  //         return `${hours}h`;
  //     } else if (minutes >= 1) {
  //         return `${minutes}m`;
  //     } else {
  //         return `${seconds}s`;
  //     }
  // }
  
    // Ensure you have your Shopify Storefront Access Token and Domain
    const SHOPIFY_STOREFRONT_ACCESS_TOKEN = '49964f27accaf3e170b2219a1a9208e5'; // Replace with your actual token
    const SHOPIFY_STORE_DOMAIN = 'athletes-direct.myshopify.com'; // Replace with your actual Shopify domain
    
    // Function to fetch articles from Shopify Storefront GraphQL API by tag using jQuery.ajax
    function getArticle(tag, id) {
        console.log(`Fetching articles for tag: ${tag} using jQuery.ajax`);
    
        // The GraphQL query string, with the 'tag' variable directly embedded
        const graphqlQuery = `{ 
            articles(first: 5, query: "tag:${tag}", sortKey: UPDATED_AT, reverse: true) { 
                edges { 
                    node { 
                        id 
                        title 
                        handle
                        publishedAt 
                        blog { 
                            handle 
                        }
                        collectionNameMetafield: metafield(namespace: "custom", key: "_image_credit") {
                            value
                            type
                        }
                    } 
                } 
            } 
        }`;
    
        var settings = {
            "url": `https://${SHOPIFY_STORE_DOMAIN}/api/2024-04/graphql.json`, // Use template literal for domain
            "method": "POST",
            "timeout": 0, // 0 for no timeout, or set a value in milliseconds
            "headers": {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_ACCESS_TOKEN
            },
            "data": JSON.stringify({
                "query": graphqlQuery // Pass your constructed GraphQL query
            }),
        };
    
        $.ajax(settings)
            .done(function (response) {
                console.log("jQuery.ajax Response:", response);
    
                // Check for GraphQL errors in the response
                if (response.errors) {
                    console.error("GraphQL Errors:", response.errors);
                    const selector = document.getElementById(id);
                    if (selector) {
                        selector.innerHTML = `<p>Error loading articles for "${tag}": ${response.errors[0].message}</p>`;
                    }
                    return; // Stop execution if there are GraphQL errors
                }
    
                const articles = response.data.articles.edges.map(edge => edge.node);
                console.log("Fetched Articles:", articles);
    
                const selector = document.getElementById(id);
                if (!selector) {
                    console.error(`Element with ID '${id}' not found.`);
                    return;
                }
                selector.innerHTML = ""; // Clear existing content
                const ulElement = document.createElement("ul");
                selector.appendChild(ulElement);
    
                if (articles && articles.length > 0) {
                    articles.forEach(article => {
                        const formattedTimeDifference = formatTimeDifference(article.publishedAt);
                        // console.log(article.title); // Already logged above
                        // console.log(article.handle); // Already logged above
    
                        const liElement = document.createElement("li");
                        const aElement = document.createElement("a");
                        const timeSpan = document.createElement("span");
    
                        // Construct the correct Shopify article URL
                        aElement.href = `https://${SHOPIFY_STORE_DOMAIN}/blogs/${article.blog.handle}/${article.handle}`;
                        aElement.innerHTML = article.title;
                        timeSpan.innerHTML = formattedTimeDifference;
    
                        liElement.appendChild(aElement);
                        liElement.appendChild(timeSpan);
                        ulElement.appendChild(liElement);
                    });
                } else {
                    console.log(`No articles found for the tag: ${tag}`);
                    selector.innerHTML = `<p>No articles found for "${tag}".</p>`; // Provide feedback
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                // Handle AJAX errors (network issues, non-2xx HTTP responses)
                console.error('Error fetching articles via jQuery.ajax:', textStatus, errorThrown, jqXHR);
                const selector = document.getElementById(id);
                if (selector) {
                    selector.innerHTML = `<p>Error loading articles for "${tag}". Please try again later.</p>`;
                }
            });
    }
    
    // Your existing formatTimeDifference function remains the same
    function formatTimeDifference(inputDate) {
        const inputDateTime = new Date(inputDate);
        const now = new Date();
        const timeDifference = now - inputDateTime;
    
        const seconds = Math.floor(timeDifference / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(months / 12);
    
        if (years >= 1) {
            return `${years}y`;
        } else if (months >= 1) {
            return `${months}mo`;
        } else if (days >= 1) {
            return `${days}d`;
        } else if (hours >= 1) {
            return `${hours}h`;
        } else if (minutes >= 1) {
            return `${minutes}m`;
        } else {
            return `${seconds}s`;
        }
    }

if(window.screen.width > 768){
  let mainIMGHeight= $('.product__media-list .product__modal-opener').height();
  let infoDivHeight=$('.product__info-container').height();
  console.log('mainIMGHeight'+mainIMGHeight+'infoDivHeight'+infoDivHeight);
  var divHeight=0;
  if(mainIMGHeight < infoDivHeight){
    divHeight=80;
  }else{
    divHeight=mainIMGHeight-infoDivHeight;
    if(divHeight <80 ){
      divHeight=80;
    }
  }
  console.log('divHeight'+divHeight);
    $('.product_blk_ttl').parents('.product__description').find('.product_descreption-content ').css('max-height', divHeight);
  }else{
  $('.product_blk_ttl.h3').attr('is_open', false)
  }


$('.product__description  .product_blk_ttl').click(function(){
  var is_open =  $(this).attr('is_open')
  if(is_open == 'true')
  {
    $(this).removeAttr('is_open')
    let open_height = $(this).parents('.product__description').find('.product_descreption-content .product_descreption_data').innerHeight() ;
    $(this).parents('.product__description').find('.product_descreption-content ').css('max-height', 0)
  }
  else
  {
    $(this).attr('is_open', 'true')
    let open_height = $(this).parents('.product__description').find('.product_descreption-content .product_descreption_data').innerHeight() ;
    $(this).parents('.product__description').find('.product_descreption-content ').css('max-height', open_height);
  }
});


$('body').on('click', '.dashboard__card__wrapper' ,function(){
  $('.dashboard__card__wrapper').removeClass('active')
  $(this).addClass('active') ;
  $(this).find('[name="shoutoutcheckbox"]').prop('checked', true);
  var id = $(this).attr('variant_id') ;
  $('[action="/cart/add"]').find('[name="id"]').val(id);

  let price = $(this).attr('variant_price')
  $('[action="/cart/add"]').find('.player_dashbord_custon_add ').find('.btn-v_price').text(price);

});


$('body').on('click', '[data-action="save-and-add"]' ,function(){
  $('[action="/cart/add"]').find('.product-form__submit[type="submit"]').trigger('click')
  if ($(window).width() < 768) {
    $("body").removeClass("modal-opens");
    $('#DeliveryModal').hide();
    $('#show').show();
  }
  else
  {
    $('.destop_view_custom_data.video_shoutout_customfields').hide();
    $('.dashboard__cards__outerwrapper').show();
    $('product-form.product-form').show() ;
  }
});

$('body').on('change', '.custom_shotout-fields input[type="text"], .custom_shotout-fields textarea' ,function(){
  let target = $(this).attr('name')
  $('[action="/cart/add"] input[name="'+target+'"]').val($(this).val())

});

$('body').on('click', '[data-action="back-to-variants"]' ,function(){
  $('.destop_view_custom_data.video_shoutout_customfields').hide();
  $('.dashboard__cards__outerwrapper').show();
  $('product-form.product-form').show() ;
});

$( document ).ready(function() {
  $('body').on('click','.player_dashbord_custon_add', function () {
    if ($(window).width() > 768) {
      $('.destop_view_custom_data.video_shoutout_customfields').show();
      $('.dashboard__cards__outerwrapper').hide();
      $('product-form.product-form').hide() ;

    }
    else
    {
      $("body").addClass("modal-opens");
      $('#DeliveryModal').show();
    }
  });

  $(".instruction_note_btn").on('click', function () {
    $(this).parents('.custom_shotout-fields').find('[name="properties[Instruction]"]').toggle();
  });

  $('.cross-icon').on('click', function () {
    $("body").removeClass("modal-opens");
    $('#DeliveryModal').hide();
    $('#show').show();
  });

  function handler(event) { 
    $('body').css("overflow","hidden");
    $('.swipe__tab').addClass("transform");

  }
  function handler2(event) { 
    $('body').css("overflow","unset");
  }
});



var newsroom_btn = document.querySelector('.newsroom-btn');
var newsroomClose_btn = document.querySelector('.newsroomClose-btn');

$('body').on('click', '.newsroom-btn', function() {
  //   $('body').css("overflow","hidden");
  $('.newsroom_img_media').css("padding-bottom","100%");
  $('.newsroom_section h2').css("font-size","18px");
  $('.newsroom-text p').css("font-size","12px");
  $(this).siblings('.swipe__tab').addClass("transform");
  $('html, body').animate({
    scrollTop: $(".newsroom_section h1").offset().top
  }, 2000);
});

$("details").on({
  mouseenter: function(){
    $(this).attr("open","");
  },
  mouseleave: function(){
    $(this).removeAttr("open");
  }
});

$("header__menu-item.header__menu-item").hover(
  function () {
    $(this).parents('details').attr('open', '');
  }, 
  function () {
    $(this).parents('details').removeAttr('open');
  }
);
// $('.howitwork__wrapper').click(function(){

//   if($(this).siblings('.howitwork_des').hasClass("toggled")) {
//     $(this).siblings('.howitwork_des').animate({"height": "100%"}).removeClass("toggled");
//   } else {
//     $(this).siblings('.howitwork_des').animate({"height": "105px"}).addClass("toggled");
//   }

//   $(this).find('.plus').toggle();
//   $(this).find('.minus').toggle();

// });
$('.howitwork__wrapper').on('click keydown', function(event) {
  // Allow only 'click' and 'Enter' key events
  if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
    const description = $(this).siblings('.howitwork_des');
    const isToggled = description.hasClass('toggled');
    const newHeight = isToggled ? '100%' : '105px';

    description.animate({ "height": newHeight }).toggleClass('toggled');
    $(this).find('.plus').toggle();
    $(this).find('.minus').toggle();
  }
});

$(document).ready(function() {
  $("#shopify-section-template--15086830125223__main .product__card").hide();
  $("#shopify-section-template--15086830125223__main .product__card").addClass('al');
  var count = $("#shopify-section-template--15086830125223__main #product-grid").children().length;

  if(window.outerWidth < 768) {

    $("#shopify-section-template--15086830125223__main .product__card:lt(4)").show();
    $("#shopify-section-template--15086830125223__main .product__card:lt(4)").removeClass('al');

    if(count > 4){
      $("#shopify-section-template--15086830125223__main #product-grid").append('<div style="width: 100%;" class="main-add-to-cart-btn"><button id="v_but" class="quick-add-btn">View more</button></div>');
    }
  } else{
    $("#shopify-section-template--15086830125223__main .product__card:lt(8)").show();
    $("#shopify-section-template--15086830125223__main .product__card:lt(8)").removeClass('al');

    if(count > 8){
      $("#shopify-section-template--15086830125223__main #product-grid").append('<div style="width: 100%;" class="main-add-to-cart-btn"><button id="v_but" class="quick-add-btn">View more</button></div>');
    }

  }
  $("#v_but").click(function(){
    $("#shopify-section-template--15086830125223__main .product__card.al:lt(4)").show();
    $("#shopify-section-template--15086830125223__main .product__card.al:lt(4)").removeClass('al');
    var co = $("#shopify-section-template--15086830125223__main #product-grid .al").length;
    if(co < 1){
      $('#shopify-section-template--15086830125223__main #product-grid #v_but').parent('.main-add-to-cart-btn').hide();
    }

  });
});

document.addEventListener('keyup', e => {
  if(e.target.matches('.searchBox')) {
    var _string= "";
    if(window.outerWidth > 768){
      _string = $('.searchBox.desktop').val();
      $('.predective-search.p-desktop').removeClass('custom--show');
    } else{
      _string = $('.searchBox.mobile').val();
      $('.predective-search.p-mobile').removeClass('custom--show');
    }
    if(_string == ""){
      return false; 
    }
    console.log(_string);   

    $('.search-keyword').text('"'+_string+'"');
    $('.search-for a').attr('href','/search?q='+_string);     
    jQuery.getJSON("/search/suggest.json", {
      "q": _string,
      "resources": {
        "type": "product,collection",   
        "limit": 4   
      }
    }).done(function(response) {
      console.log(response.resources.results);
      var _data = response.resources.results; 
      if(_data.products.length == 0 && _data.collections.length == 0 && _data.pages.length == 0){
        if(window.outerWidth > 768){
          $('.predective-search.p-desktop').addClass('custom--show');
        } else{
          $('.predective-search.p-mobile').addClass('custom--show');
        }
        $('.predictive-products').hide();
        $('.predictive-collections').hide();
        $('.no-products').show();
        return false;
      }
      $('.no-products').hide();   
      if(window.outerWidth > 768){
        $('.predective-search.p-desktop').addClass('custom--show');
      } else{
        $('.predective-search.p-mobile').addClass('custom--show');
      }  
      if(_data.products.length > 0){  
        var _products_data = '';
        var src_priveiw='';
        _data.products.forEach(function(res){  
          if(res.tags.indexOf("search:hidden") < 0){  
            var _product_title=res.title;
            if(res.title.includes("Personalized Fan Moment") || _product_title.includes("Fan Moment") || _product_title.includes("Video") || _product_title.includes("video") || _product_title.includes("Video shoutout")){
              
              $.get("https://fanarch.com/products/"+res.handle+"?view=vedioPreview", function(data, status){
                src_priveiw=$(data).html();
                console.log(src_priveiw);
               _products_data  +=  '   			<div class="single-product-data">   '  + 
              '   			 <a href="/products/'+res.handle+'" class="single-product-anchor">  '  +   
              '   				<div class="product-img">  '  + 
              '   					<img src="'+src_priveiw+'">  '  +  
              '   				</div> <div class="product-other-data"> '  + 
              '   				<div class="product-title">'+res.title+  
              '   				</div>  ';
                 _products_data  += '<div class="product-price">$'+res.price+ 
              '   				</div>  </div> '  + 
              '   			 </a>  '  + 
              '  			</div>  ' ; 
        $('.predictive-products-data').html(_products_data);
                
              });
            }
           else{
               _products_data  +=  '   			<div class="single-product-data">   '  + 
              '   			 <a href="/products/'+res.handle+'" class="single-product-anchor">  '  +   
              '   				<div class="product-img">  '  + 
              '   					<img src="'+ res.featured_image.url +'">  '  +  
              '   				</div> <div class="product-other-data"> '  + 
              '   				<div class="product-title">'+res.title+  
              '   				</div>  ';
              _products_data  += '<div class="product-price">$'+res.price+ 
              '   				</div>  </div> '  + 
              '   			 </a>  '  + 
              '  			</div>  ' ; 
            }
            
           
          }

        });
        $('.predictive-products-data').html(_products_data);
        $('.predictive-products').show();
      }
      else{
        $('.predictive-products').hide();
      }

      if(_data.collections.length > 0){  
        var _collection_data = '';
        _data.collections.forEach(function(res){
          if(res.handle !== "autographs"){
            _collection_data  +=  '   			<div class="single-collections-data">   '  + 
              '   			 <a href="/collections/'+res.handle+'">  '  +  
              '   				<div class="collection-img">  '  + 
              '   					<img src="'+res.featured_image.url+'">  '  +  
              '   				</div> <div class="collection-title">'+res.title+  
              '   				</div>  '  +
              '   			 </a>  '  + 
              '  			</div>  ' ; 
          }
        });
        $('.predictive-collections-data').html(_collection_data);
        $('.predictive-collections').show();
      }
      else{
        $('.predictive-collections').hide();
      }   
    });

  } 

}); 

document.addEventListener('click', e => {   
  if(!(e.target.matches('[name="q"]'))){     
    if ($(e.target).closest('#predective-search').length === 0) {
      if(window.outerWidth > 768){
        $('.predective-search.p-desktop').removeClass('custom--show');
      } else{
        $('.predective-search.p-mobile').removeClass('custom--show');
      } 
    }
  }
});
$('.mobile-search').click(function(){ 
  $('div#mobile-search-box').addClass('show');    
  $('#mobile-search-area input').focus();
  $('#mobile-search-area input').click();
  if($('#mobile-search-area input').val().length > 0 ){  
    $('.mobile-cross2').show();  
  }

})  
$('.mobile-cross').click(function(){ 
  $('div#mobile-search-box').removeClass('show'); 
  if(window.outerWidth > 768){
    $('.predective-search.p-desktop').removeClass('custom--show');
  } else{
    $('.predective-search.p-mobile').removeClass('custom--show');
  } 

}) 




///// search result for search page

if($('.template-search').length > 0 ){
  var _string = $('.search__input.field__input').val();
  jQuery.getJSON("/search/suggest.json", {
    "q": _string,
    "resources": {
      "type": "collection",   
      "limit": 8
    }
  }).done(function(response) {
    var _data = response.resources.results; 
    // console.log(_data);
    if(_data.collections.length > 0){  
      var _collection_data = '';
      _data.collections.forEach(function(res){
        // console.log(res.body);
        if(res.handle !== "autographs"){
          _collection_data  +=  '   			<div class="single-collections-data-search">   '  + 
            '   			 <a href="/collections/'+res.handle+'">  '  +  
            '   				<div class="collection-img-search">  '  + 
            '   					<img src="'+res.featured_image.url+'">  '  +  
            '   				</div> <div class="collection-title-search">'+res.title+  
            '   				</div>  '  +
            '<div class="collection-desc-search">'+res.body.replace(/(<([^>]+)>)/ig,"")+  
            '   				</div>  '  +
            '   			 </a>  '  + 
            '  			</div>  ' ; 
        }
      });
      $('.custom-search-page-row').html(_collection_data);
      $('.custom-search-page-row').show();
    } 
  });
}

// Search Result for Articles

if($('.template-search').length > 0 ){
  var _string = $('.search__input.field__input').val();
  jQuery.getJSON("/search/suggest.json", {
    "q": _string,
    "resources": {
      "type": "article",   
      "limit": 8
    }
  }).done(function(response) {
    var _data = response.resources.results;  
    // console.log(_data);
    if(_data.articles.length > 0){  
      var _article_data = '';
      _data.articles.forEach(function(res){
        // console.log(res);
        const d1 = res.published_at;
        var date = new Date(d1);
        var d2 = date.toDateString();'Tue Feb 10 2015'
        $('#dateart').val(res.handle);
        if(res.handle !== "autographs"){
          _article_data  +=  '   			<div class="single-article-data-search">   '  + 
            '   			 <a href="'+res.url+'">  '  +  
            '   				<div class="article-img-search">  '  + 
            '   					<img src="'+res.featured_image.url+'">  '  +  
            '   				</div> <div class="article-title-search">'+res.title+  
            '   				</div>  '+
            '<div class="article-desc-search">'+d2+  
            '   				</div>  '  +
            '   			 </a>  '  + 
            '  			</div>  ' ; 
        }
      });
      $('.custom-search-page-row-article').html(_article_data);
      $('.custom-search-page-row-article').show();
    } 
  });
}

////cart drawer plus+minus

$('body').on('click', 'button.cart-drawer-plus-minus-btn', function() {
  var _variantid = $(this).parents('.cart-drawer-plus-minus').attr('data-variant');
  var _qun = $(this).siblings('input').val();
  if($(this).hasClass('cart-drawer-plus')){
    console.log('plus');
    _qun = parseInt(_qun)+parseInt(1);
    jQuery.post('/cart/update.js',
                "updates["+_variantid+"]="+_qun
               );
    $(this).siblings('input').val(_qun);
  } else{
    _qun = parseInt(_qun)-parseInt(1);
    jQuery.post('/cart/update.js',
                "updates["+_variantid+"]="+_qun
               );
    $(this).siblings('input').val(_qun);
    if(_qun == 0){
      $(this).parents('.cart-notification-custom-items').hide();
    }
  }
  setTimeout(function(){
    $.getJSON('/cart', function(res){
      var _totl = res.total_price/100;
      $('.moneybag').html('$'+_totl);
    });
  }, 1000)
})

///// on input change updating cart drawer
$('body').on('change', '.cart-drawer-plus-minus input', function() {
  var _variantid = $(this).parents('.cart-drawer-plus-minus').attr('data-variant');
  var _qun = $(this).val();
  jQuery.post('/cart/update.js',
              "updates["+_variantid+"]="+_qun
             );
  if(_qun == 0){
    $(this).parents('.cart-notification-custom-items').hide();
  } else{
    setTimeout(function(){ 
      $.getJSON('/cart', function(res){
        var _totl = res.total_price/100;
        $('.moneybag').html('$'+_totl);
      });
    }, 1000)
  }
})

// cart drawer
$('body').on('click', '.quick-add-btn22', function() {
  setTimeout(function(){
    $(".cart-notification").addClass("active");
  },1000)
  // $('html, body').animate({
  //   scrollTop:20
  // }, 2000);
  var _id = $(this).attr('data-var');


  let formData = {
    'items': [{
      'id': _id,
      'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)

  })
  .then(response => {
    $.getJSON('/cart', function(response){
      var _totl = response.total_price/100;
      $('.moneybag').html('$'+_totl);
      var cartNotification = document.querySelector('cart-notification');
      cartNotification.renderContents(response);
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });
});
// cart notifications 


$('body').on('click', '#cart-icon-bubble', function() {
  setTimeout(function(){
    $(".cart-notification").addClass("active");
  },1000)

  $.getJSON('/cart', function(response){
    var _totl = response.total_price/100;
    $('.moneybag').html('$'+_totl);
    var cartNotification = document.querySelector('cart-notification');
    cartNotification.renderContents(response);
  });

});
